import { SeasonProcessState, SeasonTypeEnum } from '@coin/shared/core/util-enums';
import { SeasonProcessStepNav } from '../interfaces/season-process-step-nav.interface';

export const INCENTIVE_STEPS: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  {
    id: SeasonProcessState.SeasonSettings,
    icon: 'settings_applications',
    route: '/season-mgmt/season-settings',
    onlyIcon: true
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.PlanManagement, icon: 'format_list_numbered', route: '/season-mgmt/plans' },
  {
    id: SeasonProcessState.PlanAssignment,
    parentStepName: SeasonProcessState.PlanProcess,
    icon: 'manage_accounts',
    isParentStart: true,
    route: '/season-mgmt/plans/assignment'
  },
  {
    id: SeasonProcessState.PlanDesign,
    parentStepName: SeasonProcessState.PlanProcess,
    route: '/season-mgmt/plans/design'
  },
  { id: SeasonProcessState.Monitoring, icon: 'tune', route: '/season-mgmt/monitoring' },
  { id: SeasonProcessState.TargetAchievement, icon: 'stacked_bar_chart', route: '/season-mgmt/achievements' }
];

export const SOG_STEPS: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.PlanManagement, icon: 'format_list_numbered', route: '/season-mgmt/plans' },
  {
    id: SeasonProcessState.PlanAssignment,
    parentStepName: SeasonProcessState.PlanProcess,
    icon: 'manage_accounts',
    isParentStart: true,
    route: '/season-mgmt/plans/assignment'
  },
  {
    id: SeasonProcessState.PlanDesign,
    parentStepName: SeasonProcessState.PlanProcess,
    route: '/season-mgmt/plans/design'
  },
  { id: SeasonProcessState.Monitoring, icon: 'tune', route: '/season-mgmt/monitoring' }
];

export const GBR_STEPS: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.SeasonSettings, icon: 'group', route: '/season-mgmt/gbr/season-settings' },
  { id: SeasonProcessState.Monitoring, icon: 'tune', route: '/season-mgmt/gbr/requests-overview' },
  {
    id: SeasonProcessState.Evaluation,
    icon: 'tune',
    route: '/season-mgmt/gbr/requests-overview',
    parentStepName: SeasonProcessState.Monitoring
  }
];

export const SPECIAL_PAYMENT_CASH: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  {
    id: SeasonProcessState.SeasonSettings,
    icon: 'settings_applications',
    route: '/season-mgmt/season-settings',
    onlyIcon: true
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.PlanManagement, icon: 'format_list_numbered', route: '/season-mgmt/plans' },
  { id: SeasonProcessState.Monitoring, icon: 'tune', route: '/season-mgmt/monitoring' }
];

export const SPECIAL_PAYMENT_EQUITY: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  {
    id: SeasonProcessState.SeasonSettings,
    icon: 'settings_applications',
    route: '/season-mgmt/season-settings',
    onlyIcon: true
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.PlanManagement, icon: 'format_list_numbered', route: '/season-mgmt/plans' },
  { id: SeasonProcessState.Monitoring, icon: 'tune', route: '/season-mgmt/monitoring' }
];

export const EXR_STEPS: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  {
    id: SeasonProcessState.SeasonSettings,
    icon: 'settings_applications',
    route: '/season-mgmt/season-settings',
    onlyIcon: true
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.PlanManagement, icon: 'format_list_numbered', route: '/season-mgmt/plans' },
  { id: SeasonProcessState.Monitoring, icon: 'tune', route: '/season-mgmt/monitoring' }
];

export const MERIT_STEPS: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  {
    id: SeasonProcessState.SeasonSettings,
    icon: 'settings_applications',
    route: '/season-mgmt/season-settings',
    onlyIcon: true
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.SchemeManagement, icon: 'tune', route: '/season-mgmt/schemes' },
  {
    id: SeasonProcessState.BudgetSchemeAssignment,
    parentStepName: SeasonProcessState.BudgetSettings,
    icon: 'manage_accounts',
    isParentStart: true,
    route: '/season-mgmt/schemes/assignment'
  },
  {
    id: SeasonProcessState.BudgetSchemeDesign,
    parentStepName: SeasonProcessState.BudgetSettings,
    route: '/season-mgmt/schemes/budget-design'
  },
  {
    id: SeasonProcessState.Reorganization,
    route: '/season-mgmt/reorganization',
    icon: 'corporate_fare',
    featureFlag: 'meritReorganization'
  },
  { id: SeasonProcessState.SimulationManagement, icon: 'poll', route: '/season-mgmt/simulations' },
  {
    id: SeasonProcessState.ParameterInput,
    parentStepName: SeasonProcessState.BudgetCalculation,
    icon: 'calculate',
    isParentStart: true,
    route: '/season-mgmt/simulations/merit-plans'
  },
  {
    id: SeasonProcessState.ParameterInput,
    parentStepName: SeasonProcessState.BudgetCalculation,
    icon: 'calculate',
    isParentStart: true,
    hidden: true,
    route: '/season-mgmt/simulations/equity-plans'
  },
  {
    id: SeasonProcessState.ParameterInput,
    parentStepName: SeasonProcessState.BudgetCalculation,
    icon: 'calculate',
    isParentStart: true,
    hidden: true,
    route: '/season-mgmt/simulations/individual-multiplier-settings'
  },
  {
    id: SeasonProcessState.ParameterInput,
    parentStepName: SeasonProcessState.BudgetCalculation,
    icon: 'calculate',
    isParentStart: true,
    hidden: true,
    route: '/season-mgmt/simulations/position-information-settings'
  },
  { id: SeasonProcessState.BudgetAllocation, route: '/season-mgmt/publication-settings', icon: 'manage_accounts' },
  { id: SeasonProcessState.Paused, route: '/season-mgmt/publication-settings', hidden: true },
  { id: SeasonProcessState.LetterAndPayroll, route: '/season-mgmt/letter-payroll', icon: 'stacked_bar_chart' }
];

export const POSITION_EVALUATION_STEPS: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/season-mgmt/season-overview'
  },
  {
    id: SeasonProcessState.SeasonSettings,
    icon: 'settings_applications',
    route: '/season-mgmt/season-settings',
    onlyIcon: true
  },
  { id: SeasonProcessState.Population, icon: 'group', route: '/season-mgmt/population' },
  { id: SeasonProcessState.SimulationManagement, icon: 'poll', route: '/season-mgmt/simulations' },
  {
    id: SeasonProcessState.ParameterInput,
    parentStepName: SeasonProcessState.SimulationProcess,
    icon: 'account_tree',
    isParentStart: true,
    route: '/season-mgmt/simulations/validation-settings'
  },
  {
    id: SeasonProcessState.ParameterInput,
    parentStepName: SeasonProcessState.SimulationProcess,
    icon: 'account_tree',
    isParentStart: true,
    hidden: true,
    route: '/season-mgmt/simulations/placement-settings'
  },
  { id: SeasonProcessState.PublicationSettings, route: '/season-mgmt/publication-settings', icon: 'manage_accounts' },
  { id: SeasonProcessState.Monitoring, icon: 'tune', route: '/season-mgmt/monitoring' }
];

export const RESTRUCTURING_STEPS: SeasonProcessStepNav[] = [
  {
    id: SeasonProcessState.SeasonOverview,
    active: true,
    icon: 'format_list_bulleted',
    hideBreadcrumb: true,
    route: '/restructuring/seasons'
  },
  { id: SeasonProcessState.InConfiguration, icon: 'settings_applications', route: '/restructuring/season/config' },
  { id: SeasonProcessState.Population, icon: 'group', route: '/restructuring/season/population' },
  { id: SeasonProcessState.ParameterInput, icon: 'group', route: '/restructuring/season/parameter-input' },
  { id: SeasonProcessState.ParameterInput, icon: 'supervised_user_circle', route: '/restructuring/season/employees' },
  { id: SeasonProcessState.ParameterInput, icon: 'report', route: '/restructuring/season/reporting-settings' },
  { id: SeasonProcessState.ParameterInput, icon: 'commit', route: '/restructuring/season/commitment-settings' },
  { id: SeasonProcessState.PlanManagement, icon: 'group', route: '/restructuring/season/plans' },
  { id: SeasonProcessState.PlanManagement, icon: 'group', route: '/restructuring/season/plans/view-setup' },
  { id: SeasonProcessState.PlanManagement, icon: 'group', route: '/restructuring/season/plans/matrix' },
  { id: SeasonProcessState.Monitoring, icon: 'list_alt', route: '/restructuring/season/reports' },
  { id: SeasonProcessState.Monitoring, icon: 'playlist_add_check_circle', route: '/restructuring/season/commitments' }
];

export const SEASON_STEPS = {
  [SeasonTypeEnum.SOG]: SOG_STEPS,
  [SeasonTypeEnum.GBR]: GBR_STEPS,
  [SeasonTypeEnum.Merit]: MERIT_STEPS,
  [SeasonTypeEnum.IncentiveV2]: INCENTIVE_STEPS,
  [SeasonTypeEnum.SpecialPaymentCash]: SPECIAL_PAYMENT_CASH,
  [SeasonTypeEnum.SpecialPaymentEquity]: SPECIAL_PAYMENT_EQUITY,
  [SeasonTypeEnum.PositionEvaluation]: POSITION_EVALUATION_STEPS,
  [SeasonTypeEnum.ExceptionalRecognitions]: EXR_STEPS,
  [SeasonTypeEnum.Restructuring]: RESTRUCTURING_STEPS
};
